import { render, staticRenderFns } from "./JudgementsList.vue?vue&type=template&id=94407b98&scoped=true"
import script from "./JudgementsList.vue?vue&type=script&lang=js"
export * from "./JudgementsList.vue?vue&type=script&lang=js"
import style0 from "./JudgementsList.vue?vue&type=style&index=0&id=94407b98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94407b98",
  null
  
)

export default component.exports